import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Chip, Tab, Tabs } from '@rossum/ui/material';

const options = ['detail', 'queues'] as const;

const TAB_HEIGHT = 40;

export const RuleManagerTabs = ({
  value,
  parentPath,
  queuesLength,
  linkedQueuesDisabled,
}: {
  value: (typeof options)[number];
  parentPath: string;
  queuesLength: number;
  linkedQueuesDisabled: boolean;
}) => {
  const intl = useIntl();

  const { push } = useHistory();

  return (
    <Tabs
      value={value}
      onChange={(_, newValue) => push(`${parentPath}/${newValue}`)}
    >
      {options.map(page => (
        <Tab
          key={page}
          label={intl.formatMessage({
            id: `features.ruleManager.${page}.title`,
          })}
          value={page}
          disableRipple
          data-cy={`rule-manager-header-tab-${page}`}
          iconPosition="end"
          disabled={page === 'queues' && linkedQueuesDisabled}
          icon={
            page === 'queues' && queuesLength > 0 ? (
              <Chip label={queuesLength} size="small" />
            ) : undefined
          }
          sx={{
            flexShrink: 0,
            height: `${TAB_HEIGHT}px`,
            minHeight: `${TAB_HEIGHT}px`,
          }}
        />
      ))}
    </Tabs>
  );
};
